import React, { useRef } from "react";

import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { IconButton } from "@mui/material";
import { useModals } from "hooks";

export const EmailButton = () => {
  const { emailInboxModal } = useModals();
  const containerRef = useRef<HTMLButtonElement>(null);

  const handleClick = () => {
    if (!containerRef.current) return;
    emailInboxModal({ isFullScreenMode: false, anchorEl: containerRef.current });
  };

  return (
    <IconButton onClick={handleClick} ref={containerRef}>
      <EmailOutlinedIcon />
    </IconButton>
  );
};
